import { Button, ButtonGroup, ButtonProps, Flex } from '@chakra-ui/react'
import React from 'react'

import { IconChevronLeft } from '~shared-components/icons/brand/IconChevronLeft'
import { IconChevronRight } from '~shared-components/icons/brand/IconChevronRight'

export interface PaginationProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  analyticsProps?: { [key: string]: any }
  currentPage: number
  onGoToPage: (pageNr: number) => void
  showFirstAndLast?: boolean
  totalPages: number
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onGoToPage,
  analyticsProps = {},
  showFirstAndLast = true,
}) => {
  const hasNextPage = currentPage + 1 <= totalPages
  const hasPreviousPage = currentPage - 1 > 0

  const PageButton: React.FC<ButtonProps> = props => (
    <Button {...props} {...analyticsProps} />
  )

  return (
    <Flex justifyContent="center" mt={[5, 10]} width="100%">
      <ButtonGroup
        border={0}
        outline="none"
        size="sm"
        sx={{ '> *': { fontSize: 'md' } }}
        variant="solid"
      >
        <PageButton
          color="neutral.50"
          disabled={!hasPreviousPage}
          onClick={() => onGoToPage(currentPage - 1)}
        >
          <IconChevronLeft boxSize="20px" />
        </PageButton>

        {currentPage > 2 && showFirstAndLast && (
          <PageButton onClick={() => onGoToPage(1)}>1</PageButton>
        )}

        {currentPage > 3 &&
          showFirstAndLast &&
          (currentPage === 4 ? (
            <PageButton onClick={() => onGoToPage(2)}>2</PageButton>
          ) : (
            <PageButton pointerEvents="none">...</PageButton>
          ))}

        {hasPreviousPage && (
          <PageButton onClick={() => onGoToPage(currentPage - 1)}>
            {currentPage - 1}
          </PageButton>
        )}

        <PageButton pointerEvents="none" variant="outline">
          {currentPage}
        </PageButton>

        {hasNextPage && (
          <PageButton onClick={() => onGoToPage(currentPage + 1)}>
            {currentPage + 1}
          </PageButton>
        )}

        {currentPage < totalPages - 2 &&
          showFirstAndLast &&
          (currentPage === totalPages - 3 ? (
            <PageButton onClick={() => onGoToPage(totalPages - 1)}>
              {totalPages - 1}
            </PageButton>
          ) : (
            <PageButton pointerEvents="none">...</PageButton>
          ))}

        {currentPage < totalPages - 1 && showFirstAndLast && (
          <PageButton onClick={() => onGoToPage(totalPages)}>
            {totalPages}
          </PageButton>
        )}

        <PageButton
          color="neutral.50"
          disabled={!hasNextPage}
          onClick={() => onGoToPage(currentPage + 1)}
        >
          <IconChevronRight boxSize="20px" />
        </PageButton>
      </ButtonGroup>
    </Flex>
  )
}
